import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {FieldDefinition} from '@shared/models/field-definition';
import {TaskManagerService} from '../../../services/task-manager.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { QueryProvider } from '@shared/queries/query-provider';
import { IQueryState } from '@shared/store/reducers/query.reducer';
import { select, Store } from '@ngrx/store';
import { getQueryResponse } from '@shared/store/selectors/query.selector';
import { TaskManagerQuery } from '../../../helpers/task-manager.query';
import { QueryModel } from '@shared/models/query-model';
import { TaskManagerConfig } from '../../../helpers/task-manager.config';
import { GraphQLService } from '@core/services/graphql.service';
import { GraphqlContentScope } from '@shared/models/graphql-content-scope.model';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import {TaskMenuDetails} from "../../../models/task-manager.model";

@Component({
    standalone: false,
    selector: 'particle-task-cell-viewer',
  templateUrl: './task-cell-viewer.component.html',
  styleUrls: ['./task-cell-viewer.component.scss']
})
export class TaskCellViewerComponent implements OnInit, CellComponent, OnDestroy {
  invalidateSubject?: InvalidateSubject;
  item: any;
  taskInfo: any;
  fieldDefinition: FieldDefinition;
  sourceType: string;
  disabled: boolean;
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  constructor(private taskManagerService: TaskManagerService, private store: Store<IQueryState>, private graphQLService: GraphQLService) { }
  unsubscribe$ = new Subject<void>();
  ngOnInit() {

  }
  onTaskInfo() {
    if (!this.item.cells['Task']) {return; }
    const query  = TaskManagerQuery.getSelectedTaskInfo(this.item.cells['Task'].value.id, GraphqlContentScope.getScope(this.item.cells['Task'].value.scopeInt));
    this.graphQLService.executePostRequest(TaskManagerConfig.TaskManagerApiKey, query).pipe(takeUntil(this.unsubscribe$)).subscribe((response: any) => {
      if (!response) {
        return;
      }
      this.taskInfo = response.data.ticket;
    });
  }
  onClick() {
    if (this.item.cells[this.fieldDefinition.key] && this.item.cells[this.fieldDefinition.key].displayText && this.fieldDefinition.metaData) {
      const menuId = this.fieldDefinition.metaData.TaskMenuId;
      if(menuId) {
        this.openCertainMenuInTask(menuId);
      }
    }
    if (this.item.cells[this.fieldDefinition.key] && this.item.cells[this.fieldDefinition.key].displayText ) {
      console.log('Open Task');
      const task = this.item.cells[this.fieldDefinition.key].value;
      if (task && task.ticketId && task.boardScope) {
        this.taskManagerService.openTaskByTaskId(task.ticketId, GraphqlContentScope.getScope(task.boardScope) )
          .pipe(take(1)).subscribe(state => {
            this.valueChanged.emit({
              item: this.item,
              fieldDefinition: this.fieldDefinition,
              action: {id: 'TaskClosed'},
              updatedState: state
            });
        });
      } else {
        this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, action: {id: 'OpenTask'}});
      }
    } else {
      console.log('Add Task');
      this.taskManagerService.openTaskSelector(null, null, false).pipe(take(1)).subscribe(selectedTask => {
        console.log(selectedTask);
        if(selectedTask){
          this.valueChanged.emit({item: this.item, fieldDefinition: this.fieldDefinition, action: {id: 'AttachCustomTaskToItem'}, payload: selectedTask});
        }
      });
    }
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  private openCertainMenuInTask(menuId: string) {
    const task = this.item.cells[this.fieldDefinition.key].value;
    const taskMenuDetails = new TaskMenuDetails();
    taskMenuDetails.id = menuId;
    if (task && task.ticketId && task.boardScope) {
      this.taskManagerService.openTaskByTaskId(task.ticketId, GraphqlContentScope.getScope(task.boardScope), null, null, taskMenuDetails, false)
        .pipe(take(1)).subscribe(state => {
        this.valueChanged.emit({
          item: this.item,
          fieldDefinition: this.fieldDefinition,
          action: {id: 'TaskClosed'},
          updatedState: state
        });
      });
    }
  }
}
